import { Property } from '../../Interface/Response/ProductProperty/List/PropertiesByCategory';

export enum PropertiesType {
    PropertiesLoaded = 'PropertiesLoaded',
}

export interface PropertiesLoadedAction {
    type: PropertiesType.PropertiesLoaded;
    properties: Property[];
}

export const propertiesLoaded = (properties: Property[]): PropertiesLoadedAction => ({
    type: PropertiesType.PropertiesLoaded,
    properties,
});

export type PropertiesActionTypes = PropertiesLoadedAction;
